module.exports = __webpack_public_path__ + "static/media/013.d36c4a1c.jpg";